<nav class="sidebar">
  <ul class="sidebar-menu">
    <li>
      <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <span class="menu-icon"><i class="home icon"></i></span>
        <span class="menu-label">首页</span>
      </a>
    </li>
    <li>
      <a routerLink="/favorites" routerLinkActive="active">
        <span class="menu-icon"><i class="star icon"></i></span>
        <span class="menu-label">收藏</span>
      </a>
    </li>
  </ul>
</nav>
